import { number } from 'prop-types';
import React from 'react';

import { countries } from '../../constants';
import CurrencyFormat from '../../generic/CurrencyFormat';
import QuoteLineCountryTableHeaders from './QuoteLineCountryTableHeaders';

function QuoteLineTableSum({
  netClientBudgetExternal,
  wkzBudget,
  coInvest,
  freeServiceValue,
  grossOfferValue,
  spendableBudget,
}) {
  return (
    <tr>
      <td colSpan="2" />
      <td className="sticky-left sticky-left-header" />
      <td>Sum</td>
      <td>
        <CurrencyFormat
          value={netClientBudgetExternal}
          className="text-nowrap"
          text
        />
      </td>
      <td>
        <CurrencyFormat value={wkzBudget} className="text-nowrap" text />
      </td>
      <td>
        <CurrencyFormat value={coInvest} text />
      </td>
      <td>
        <CurrencyFormat value={freeServiceValue} text />
      </td>
      <td>
        <CurrencyFormat value={grossOfferValue} text />
      </td>
      <td />
      <td>
        <CurrencyFormat value={spendableBudget} text />
      </td>
      <td colSpan="2" />
      <QuoteLineCountryTableHeaders countries={countries} />
    </tr>
  );
}

QuoteLineTableSum.propTypes = {
  netClientBudgetExternal: number.isRequired,
  wkzBudget: number.isRequired,
  coInvest: number.isRequired,
  freeServiceValue: number.isRequired,
  grossOfferValue: number.isRequired,
  spendableBudget: number.isRequired,
};

export default QuoteLineTableSum;
